import { enUS } from 'date-fns/locale'

export const WORDLENGTH = 6
export const WORDLENGTHR = 7
export const CHALLENGESR = 6
export const CHALLENGES = 6
export const ALERT_TIME_MS = 2500
export const EXPL_TIME_MS = 5000
export const LONG_ALERT_TIME_MS = 10000
export const REVEAL_TIME_MS = 350
export const WELCOME_INFO_MODAL_MS = 350
export const DISCOURAGE_INAPP_BROWSERS = true
export const ENABLE_MIGRATE_STATS = false
export const BLOWFISH_KEY = 'xcQUAHsik#Thq&LG*8es2DsZ$3bw^e'
export const BLOWFISH_IV = '#45XmF^w'
export const ENABLE_ARCHIVED_GAMES = false
export const DATE_LOCALE = enUS
